/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const calendarProviderSchema = z.enum(['google', 'microsoft_365'])

export type CalendarProviderSchema = z.infer<typeof calendarProviderSchema>
